import React from "react";
import { Carousel } from "react-bootstrap";

export default function Testimonials() {
  const reviews = [
    {
      name: "Marie L.",
      text: "Service impeccable et ponctuel ! Véhicule très confortable.",
    },
    {
      name: "Jean P.",
      text: "Chauffeur professionnel, ponctuel et accueillant. Je recommande !",
    },
    {
      name: "Claire D.",
      text: "Voyage agréable et facile à réserver. Très satisfait.",
    },
  ];

  return (
    <section className="testimonials-section py-5 text-center">
      <h2 className="mb-4">Avis Clients</h2>
      <Carousel indicators={false} controls={true} interval={5000}>
        {reviews.map((r, idx) => (
          <Carousel.Item key={idx}>
            <p className="fs-5 fst-italic">"{r.text}"</p>
            <p className="fw-bold mt-2">{r.name}</p>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
}
